import React from 'react';

// MAIN COMPONENT
const UserName = ({ value, children = value, placeholder }) =>
  children?.first_name || children.last_name ? (
    <span>
      {children.first_name}&nbsp;{children.last_name}
    </span>
  ) : (
    placeholder
  );

//EXPORT
export default UserName;
